import React, { Component } from 'react';

class ModalConfirmarDetalleAsiento extends Component {
    constructor(props) {
        super(props);
    }

    render() {
          //ACTIONS
          const {
            descargarExcel,
            mostrarOcultarModalAsientosContables
        } = this.props;
        
        return (
            <div className="modalContainer">
                <div className="modalDemandaOutXS">
                    <div className="text-right">
                        <label
                            onClick={() =>
                                mostrarOcultarModalAsientosContables(
                                    'modalConfirmarDetalleAsiento',
                                    false
                                )
                            }
                            className="ti-close clickable ABMModelos__modalConfirmarEliminacionRenglon__botonCerrar"
                        ></label>
                    </div>
                    <div className="modalConfirmarSalirTexto">
                        ¿Quiere incluir los detalles de los asientos también?
                    </div>
                    <div className="modalProcesosFooterShort">
                        <button
                            onClick={() => descargarExcel(null, false)}
                            className="btn btn-secondary"
                        >
                            No
                        </button>
                        <button
                            onClick={() => descargarExcel(null, true)}
                            className="btn btn-cta"
                        >
                            Sí
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalConfirmarDetalleAsiento;
